import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import PubNub from 'pubnub';
import { PubNubProvider } from 'pubnub-react';
import * as serviceWorker from './serviceWorker';
import Routes from './common/routes';
import { store } from './store';
import './index.css';
import './assets/css/custom.css';

const pubnub = new PubNub({
  publishKey: 'pub-c-d94d1fef-b761-49d1-b730-f107fb24acef',
  subscribeKey: 'sub-c-838fe694-d659-11ea-9485-d6b39d8ad52f',
});

ReactDOM.render(
  <React.StrictMode>
    <PubNubProvider client={pubnub}>
      <Provider store={store}>
        <Router>
          <Routes />
        </Router>
      </Provider>
    </PubNubProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
